export default "__VITE_ASSET__BNzONiUx__"